module.exports = "<p>\n  employees-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/employees/employees-form/employees-form.component.html
// module id = ./src/app/employees/employees-form/employees-form.component.html
// module chunks = main